import { combineReducers } from "redux"
import { authentication, configuration, navigationSidebar } from "./modules"

const reducer = combineReducers({
	authentication,
	configuration,
	navigationSidebar
})

export default reducer



// WEBPACK FOOTER //
// ./src/redux/reducer.js